// Import action types related to Invest Relation data
import {
  INVREL_ARE_LOADING,
  INVREL_FETCH_DATA_SUCCESS,
  INVREL_HAVE_ERROR,
} from "../actionType";

// Define the initial state for the Invest Relation reducer
const initialState = {
  data: [],
  loading: true,
  error: [],
};

// Reducer function to handle Invest Relation-related actions and update state accordingly
export function InvRelReducer(state = initialState, action) {
  switch (action.type) {
    // Handle error case when fetching Invest Relation data
    case INVREL_HAVE_ERROR:
      return {
        ...state,
        error: action.hasError, // Update the error state with the error from the action
        loading: false, // Set loading to false since the request is complete
      };

    // Handle loading state when Invest Relation data is being fetched
    case INVREL_ARE_LOADING:
      return {
        ...state,
        loading: action.isLoading, // Update the loading state with the loading status from the action
      };

    // Handle success case when Invest Relation data is successfully fetched
    case INVREL_FETCH_DATA_SUCCESS:
      return {
        ...state,
        data: action.InvRel, // Update the data state with the fetched Invest Relation data
        loading: false, // Set loading to false since the request is complete
        error: [], // Clear any previous errors (assuming the success case means no error)
      };

    // Return the current state by default if action type is not recognized
    default:
      return state;
  }
}
